import { compose } from 'ramda';
import { createAction } from 'redux-actions';
import { push } from 'connected-react-router';

import { PLANS_FETCHED } from 'app/features/plans/actionTypes';
import { userSessionId, userLocale } from 'app/features/user/selectors';
import { getAppName } from 'app/router/selectors';
import { INTERNAL_FOUR_O_FOUR } from 'app/router/constants/paths';
import localizeLink from 'app/features/localization/localizeLink';

const plansFetched = createAction(PLANS_FETCHED);

function fetchPlans() {
  return (dispatch, getState, { api }) => {
    const sessionId = userSessionId(getState());
    const locale = userLocale(getState());
    const notFoundPath = `/${getAppName(getState())}${INTERNAL_FOUR_O_FOUR}`;

    return api
      .fetchPlans({ sessionId, locale })
      .then(compose(dispatch, plansFetched))
      .catch(() => dispatch(push(localizeLink(notFoundPath, locale))));
  };
}

export { fetchPlans };
